import React, { ReactNode, Ref } from 'react';
import { AgencyList } from './styled';

interface AgencyFilterResultsListProps {
  children: ReactNode;
  forwardedRef: Ref<HTMLDivElement>;
}

export const AgencyFilterResultsList: React.FC<
  AgencyFilterResultsListProps
> = ({ forwardedRef, children }) => {
  return <AgencyList ref={forwardedRef}>{children}</AgencyList>;
};
